import dayjs from 'dayjs';

export const getDayjsDate = (date) => date && dayjs(date, 'YYYY-MM-DD');

export const formatDateToResponse = (date) => {
  if (date) {
    return dayjs(date).format('YYYY-MM-DD');
  }
  return null;
};
